/** Maps CRM route paths to their i18n translation keys (nav namespace). */
export const ROUTE_I18N_KEYS: Record<string, string> = {
  '/dashboard': 'nav.dashboard',
  '/analytics': 'nav.analytics',
  '/reports': 'nav.analytics',
  '/vault': 'nav.vault',
  '/tasks': 'nav.tasks',
  '/calendar': 'nav.calendar',
  '/messenger': 'nav.messenger',
  '/admin': 'nav.admin',
  '/bpms': 'nav.bpms',
  '/marketing': 'nav.marketing',
  '/marketing/leads': 'nav.marketingLeads',
  '/marketing/landing': 'nav.marketingLanding',
  '/marketing/post': 'nav.marketingPost',
  '/client-requests': 'nav.clientRequests',
  '/wealth': 'nav.wealth',
  '/wealth/investors': 'nav.wealthInvestors',
  '/wealth/accounts': 'nav.wealthAccounts',
  '/wealth/documents': 'nav.wealthDocuments',
  '/transactions': 'nav.transactions',
  '/vault/$fileId': 'nav.vaultFile',
  '/marketplace': 'nav.marketplace',
  '/invoices': 'nav.invoices',
  '/invoices/stripe': 'nav.invoicesStripe',
  '/security': 'nav.security',
  '/security/users': 'nav.securityUsers',
  '/security/roles': 'nav.securityRoles',
  '/security/logs': 'nav.securityLogs',
  '/security/sessions': 'nav.securitySessions',
  '/security/audit': 'nav.securityLogs',
  '/ai-cio': 'nav.aiCio',
  '/new-tab': 'nav.newTab',
  '/settings': 'nav.settings',
  '/settings/profile': 'nav.settingsProfile',
  '/settings/ai-customization': 'nav.settingsAiCustomization',
  '/settings/company': 'nav.settingsCompany',
};
